import { render, staticRenderFns } from "./WsExpertsList.vue?vue&type=template&id=3724768e"
import script from "./WsExpertsList.vue?vue&type=script&lang=js"
export * from "./WsExpertsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports